// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/ActionsAction/Edit/Content/Charges/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Procedures_Content_Content_Procedure_ActionsAction_Edit_Content_Charges($location_id: uuid!) {
  vaxiom_misc_fee_charge_templates(
    where: { organization: { _id: { _eq: $location_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    text: name
    price
  }
}

`